import {AbstractEvent} from "@/modules/base/events";
import {Player, Team} from "@/modules/team/entity";

export class AfterTransferEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public team: Team,
    public price: number,
  ) {
    super();
  }
}